// v3.7.2: Extracted from ChatSidebar.tsx — pure utility functions
export function formatRelativeTime(date: string, now: Date = new Date(), isZh: boolean = true): string {
  const d = new Date(date);
  const diffMs = now.getTime() - d.getTime();
  const diffMin = Math.floor(diffMs / 60000);
  if (diffMin < 1) return '刚刚';
  if (diffMin < 60) return diffMin + '分钟前';
  const diffHr = Math.floor(diffMin / 60);
  if (diffHr < 24) return diffHr + '小时前';
  const diffDay = Math.floor(diffHr / 24);
  if (diffDay < 7) return diffDay + '天前';
  return d.toLocaleDateString('zh-CN', { month: 'short', day: 'numeric' });
}

export function planProgress(plan: any): number {
  if (!plan || !plan.steps || plan.steps.length === 0) return 0;
  const done = plan.steps.filter((s: any) => s.status === 'done').length;
  return Math.round((done / plan.steps.length) * 100);
}

export function planStatusColor(status: string): string {
  // v3.7.3 fix: 返回 hex 颜色 (与 ChatSidebar 内部一致), NOT Tailwind class
  switch (status) {
    case 'done': return '#34D399';
    case 'active': case 'running': return '#FBBF24';
    case 'error': case 'failed': case 'cancelled': return '#EF4444';
    default: return '#6D28D9';
  }
}

